export enum FutureDateCalculationMethod {
  YearToDate = "YearToDate",
  RollToCalendarYear = "RollToCalendarYear",
  RollToCustomFutureDate = "RollToCustomFutureDate",
}

export const FutureDateCalculationMethodList = () =>
  Object.entries(FutureDateCalculationMethod).map(([label, value]) => {
    return { label, value };
  });
